import { Link } from 'react-router-dom';
import PhoneMenu from './PhoneMenu';

interface Props {
  onContactClick: () => void;
}

const legalLinks = [
  { label: 'Impressum', path: '/impressum' },
  { label: 'Datenschutz', path: '/datenschutz' },
];

const Footer = ({ onContactClick }: Props) => {
  return (
    <>
      <div className="mx-8 h-px bg-gradient-to-r from-transparent via-ak-sky/20 to-transparent" />
      <footer className="mx-auto w-full max-w-[1152px] px-8 py-5">
        <div className="flex flex-wrap items-center justify-between gap-4">

          {/* Brand + Copyright */}
          <div className="flex items-center gap-3">
            <img src="/assets/logo_square_96.png" alt="AK TechSolutions Logo" width={28} height={28} className="h-7 w-7 object-contain" />
            <div>
              <span className="text-[13px] font-bold text-white">Alexander Krein</span>
              <span className="text-[13px] font-medium text-ak-sky"> · TechSolutions</span>
            </div>
            <span className="ml-1 text-xs text-ak-dim">© 2026</span>
          </div>

          {/* Kontakt */}
          <address className="flex flex-wrap items-center gap-5 not-italic">
            <a
              href="mailto:requests@aktechsolutions.de"
              className="flex items-center gap-1.5 text-xs text-ak-dim no-underline transition-colors hover:text-ak-sky"
            >
              <i className="pi pi-envelope text-[11px]"></i>
              requests@aktechsolutions.de
            </a>
            <PhoneMenu />
            <button
              onClick={onContactClick}
              className="flex cursor-pointer items-center gap-1.5 border-0 bg-transparent p-0 font-sans text-xs text-ak-dim transition-colors hover:text-ak-sky"
            >
              <i className="pi pi-send text-[11px]"></i>
              Kontakt
            </button>
          </address>

          {/* Legal + Exali */}
          <div className="flex items-center gap-4">
            {legalLinks.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                className="text-xs text-ak-dim no-underline transition-colors hover:text-ak-muted"
              >
                {l.label}
              </Link>
            ))}
            <a
              href="https://www.exali.de/siegel/Alexander-Krein-Techsolutions_2168"
              target="_blank"
              rel="nofollow noreferrer"
              title="Mehr über die IT-Haftpflicht von Alexander Krein Techsolutions"
              className="block leading-none opacity-75 transition-opacity hover:opacity-100"
            >
              <img
                src="https://www.exali.de/siegel/siegel_de-2_43f43becb8be737ce9e1ba6814ba9d57.png"
                width="40"
                height="40"
                alt="IT-Haftpflicht Exali"
                className="block"
              />
            </a>
          </div>

        </div>
      </footer>
    </>
  );
};

export default Footer;
